import 'url-search-params-polyfill';

export default class UrlParamsHelper {
  static getParamAfter(urlPrefix, _window = window) {
    const parts = _window.location.href.split(urlPrefix);
    if (parts.length < 2) {
      return null;
    }

    const param = parts[1].split('/')[0].split('?')[0];
    return param;
  }

  static getSearchFromParams(group) {
    if (!group) {
      return '';
    }

    const urlParams = new URLSearchParams();

    Object.keys(group).forEach(key => {
      const entry = group[key];

      if (Array.isArray(entry)) {
        entry.forEach(innerEntry => {
          urlParams.append(key, innerEntry);
        });

        return;
      }

      urlParams.append(key, entry);
    });

    return urlParams.toString();
  }

  static getParamsFromCurrentUrl(_document = document) {
    const urlParams = new URLSearchParams(_document.location.search);
    const params = {};

    for (let key of urlParams.keys()) {
      const paramValues = [];
      const values = urlParams.getAll(key);
      values.forEach(v => {
        if (v === 'false') {
          paramValues.push(false);
          return;
        }
        if (v === 'true') {
          paramValues.push(true);
          return;
        }

        const intVal = +v;
        if (!isNaN(intVal)) {
          paramValues.push(intVal);
          return;
        }

        paramValues.push(v);
      });

      params[key] = paramValues;
    }

    return params;
  }

  static getSingleParamFromCurrentUrl(paramName, _document = document) {
    if (!_document.location.search) {
      return null;
    }

    const urlParams = new URLSearchParams(_document.location.search);
    return urlParams.get(paramName);
  }
}
